"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogContentText_1 = __importDefault(require("@material-ui/core/DialogContentText"));
var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
var components_1 = require("@xyo-network/coin-forms/build/lib/components");
var DropDetails_1 = require("../DropDetails");
var Box_1 = __importDefault(require("@material-ui/core/Box"));
function ConfirmCreateGeoDrop(_a) {
    var loading = _a.loading, details = _a.details, onCancel = _a.onCancel, onConfirm = _a.onConfirm;
    return (react_1.default.createElement(Dialog_1.default, { open: Boolean(details), onClose: onCancel },
        loading && react_1.default.createElement(LinearProgress_1.default, null),
        react_1.default.createElement(DialogTitle_1.default, null, "Confirm Geodrop Details"),
        react_1.default.createElement(DialogContent_1.default, null,
            react_1.default.createElement(DialogContentText_1.default, null, "Your funds will be collected immediately after confirmation. Drops can be recalled up until they have been claimed by a user."),
            react_1.default.createElement(DropDetails_1.DropListDetails, __assign({}, details, { total: details ? (details.amount || 0) * (details.quantity || 1) : 0, loading: false }))),
        react_1.default.createElement(DialogActions_1.default, null,
            react_1.default.createElement(Button_1.default, { color: "primary", onClick: onCancel }, "Cancel"),
            react_1.default.createElement(Box_1.default, { ml: 2 },
                react_1.default.createElement(components_1.LoadingButton, { color: "secondary", variant: "contained", loading: loading, onClick: onConfirm }, "Confirm")))));
}
exports.ConfirmCreateGeoDrop = ConfirmCreateGeoDrop;
//# sourceMappingURL=Confirm.js.map